<template>
  <div
    class="zj-layout-main-content bgcolor scrollable"
    style="overflow: auto;"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">站台管理详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <zj-layout-main>
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="16rem"
          style="width: 80%;"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="站台编号" prop="StationId">
                <el-input
                  v-model="data.StationId"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="站台名称" prop="StationName">
                <el-input
                  v-model="data.StationName"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="站台类型" prop="StationType">
                <el-select
                  v-model="data.StationType"
                  :disabled="!IsEdit"
                  placeholder="请选择"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in StationTypeArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="票价" prop="TicketPrice">
                <el-input
                  v-model="data.TicketPrice"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="经度" prop="Longitude">
                <el-input
                  v-model="data.Longitude"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="纬度" prop="Latitude">
                <el-input
                  v-model="data.Latitude"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <ZjLngLatSelect
              class="newtaskposition"
              :point_lat="data.Latitude"
              :point_lng="data.Longitude"
              @onGotLngLat="onGotLngLat"
            ></ZjLngLatSelect>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" prop="Expend1">
                <el-input
                  v-model="data.Expend1"
                  :disabled="!IsEdit"
                  type="textarea"
                  :autosize="{ minRows: 2 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-form-item class="right" style="width:134rem;">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="saveForm()"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";

export default {
  name: "StationManagerInfo",
  controller: "UI",
  action: "StationManagerInfo",
  data() {
    return {
      data: {
        StationType: "",
        Latitude: "",
        Longitude: "",
      },
      StationTypeArr: [
        { value: "单行", label: "单行" },
        { value: "上行", label: "上行" },
        { value: "下行", label: "下行" },
      ],
      IsEdit: false,
      rules: {
        StationId: [
          { required: true, message: "请输入站台编号", trigger: "blur" },
        ],
        StationName: [
          { required: true, message: "请输入站台名称", trigger: "blur" },
        ],
        StationType: [
          { required: true, message: "请选择站台类型", trigger: "change" },
        ],
        TicketPrice: [
          {
            required: false,
            message: "请输入有效的票价",
            trigger: "blur",
            pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
          },
        ],
        Longitude: [
          {
            required: false,
            message: "请输入有效的经度",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/,
          },
        ],
        Latitude: [
          {
            required: false,
            message: "请输入有效的纬度",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/,
          },
        ],
      },
    };
  },
  created: function() {
    if (this.$route.query.InfoId) {
      this.search();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
  },
  watch: {
    $route: function() {
      if (this.$route.query.InfoId) {
        this.search();
      }
    },
  },
  methods: {
    onGotLngLat(obj) {
      this.data.Latitude = obj.lat || 0;
      this.data.Longitude = obj.lng || 0;
    },
    search() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        let searchInfo = {
          ID: InfoId,
        };
        new MyApis.StationsApi()
          .GeItemById(searchInfo)
          .then((r) => {
            r = r.data.Data;
            this.data = r;
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存
    saveForm() {
      const that = this;
      that.$refs.form.validate((valid) => {
        if (valid) {
          that.GetStations(function(data) {
            if (!data) {
              that.saveData();
            }
          });
        } else {
          return false;
        }
      });
    },
    //检验是否有重复记录
    GetStations(callback) {
      let searchInfo = {
        PageSize: 100000000,
      };
      let isExistEntity = false;
      new MyApis.StationsApi()
        .GetItemPagingList(searchInfo)
        .then((r) => {
          r = r.data.Data;
          const result = r.PageContents;
          if (result != null) {
            if (this.$route.query.type == "edit") {
              const index = result.findIndex(
                (p) =>
                  (p.StationName == this.data.StationName ||
                    p.StationId == this.data.StationId) &&
                  p.Id != this.data.Id
              );
              if (index > -1) {
                this.$message.error("站台编码或名称已存在，请重新输入！");
                isExistEntity = true;
              }
            } else {
              const index = result.findIndex(
                (p) =>
                  p.StationName == this.data.StationName ||
                  p.StationId == this.data.StationId
              );
              if (index > -1) {
                this.$message.error("站台编码或名称已存在，请重新输入！");
                isExistEntity = true;
              }
            }
          }
          callback(isExistEntity);
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    saveData() {
      let uuid = "";
      if (this.$route.query.type == "edit") {
        uuid = this.$route.query.InfoId;
      } else {
        uuid = ZJApp.ZJUtils.uuid();
      }
      if (this.$route.query.type == "edit") {
        //编辑
        this.data.ModifyTime = new Date();
        this.data.Modifier = ZJApp.ZJUser.current.UserName;
        let formAll = JSON.stringify(this.data);
        formAll = JSON.parse(formAll);
        new MyApis.StationsApi()
          .UpdateItem(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "站台修改";
            this.logInfo.LogMessage = r ? "站台修改成功" : "站台修改失败";
            this.logInfo.ModuleName = "车辆调度";
            this.logInfo.PageName = "站台管理详情";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        // 增加
        let formObj = {
          Creater: ZJApp.ZJUser.current.UserName,
          CreateTime: new Date(),
          Modifier: ZJApp.ZJUser.current.UserName,
          ModifyTime: new Date(),
          Validity: 1, //新增编辑是1，删除是0
          Id: uuid,
        };
        let formAll = Object.assign(formObj, this.data);
        formAll = JSON.stringify(formAll);
        formAll = JSON.parse(formAll);
        new MyApis.StationsApi()
          .AddItem(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "站台添加";
            this.logInfo.LogMessage = r ? "站台添加成功" : "站台添加失败";
            this.logInfo.ModuleName = "车辆调度";
            this.logInfo.PageName = "站台管理详情";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
  },
};
</script>
